<template>
  <hm-content>
    <div class="table-panel flex flex-end mb20">
      <div class="flex-1 text-right">
        <el-select
          v-model="searchCondition.depotId"
          placeholder="请选择仓库"
          size="small"
          filterable
          clearable
          class="mr10"
        >
          <el-option
            :label="v.depotName"
            :value="v.depotId"
            v-for="(v, i) in depotList.records"
            :key="i"
          ></el-option>
        </el-select>
        <el-select
          clearable
          v-model="searchCondition.platFormId"
          placeholder="请选择销售渠道"
          size="small"
          filterable
          class="mr10"
        >
          <el-option
            :label="v.platformName"
            :value="v.platformId"
            v-for="(v, i) in salesChannels"
            :key="i"
          ></el-option>
        </el-select>
        <el-select
          clearable
          v-model="searchCondition.changeType"
          placeholder="请选择操作类型"
          size="small"
          filterable
          class="mr10"
        >
          <el-option
            :label="v.itemText"
            :value="v.itemValue"
            v-for="(v, i) in changeTypeList"
            :key="i"
          ></el-option>
        </el-select>
        <el-input
          clearable
          style="width: 200px"
          v-model.trim="searchCondition.keyWords"
          placeholder="请输入货号/条码/商品名/品牌"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-date-picker
        v-model="searchCondition.changeOperatorTime"
        type="datetimerange"
        align="right"
        start-placeholder="请选择时间段"
        end-placeholder="请选择时间段"
        value-format="yyyy-MM-dd HH:mm:ss"
        :default-time="['00:00:00', '23:59:59']"
        size="small"
        class=" mr10 time"
      ></el-date-picker>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="output(flowList, 'brandTable', '库存流水列表')"
          :loading="isOutputing"
          >导出</el-button
        >
        <el-button type="info" size="small" @click="searchCondition = {}"
          >重置</el-button
        >
      </div>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        ref="brandTable"
        @selection-change="getChecked"
        :data="flowList"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column header-align="center" align="center" label="SKU名称">
          <template slot-scope="scope">
            <div>
              <span>{{ scope.row.spuName }}</span>
              <span v-if="scope.row.specIdGroupName"
                >({{ scope.row.specIdGroupName }})</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="depotName"
          show-overflow-tooltip
          label="仓库名称"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="changeQty"
          label="变更数量"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="changeTypeFormat"
          label="操作类型"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="stockQty"
          label="剩余数量"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="changeOperatorName"
          label="操作人"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="changeOperatorTime"
          label="变更时间"
        >
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="flowListTotal"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
        :page-size="pageSize"
      ></el-pagination>
    </div>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import { outPutMixin } from "@/mixins/outputMixin";
import { setCookie, getCookie } from "@/utils/utils";
import moment from "moment";
export default {
  mixins: [outPutMixin],
  data() {
    return {
      tHeader: [
        "商品名称",
        "仓库名称",
        "变更数量",
        "操作类型",
        "剩余数量",
        "操作人",
        "变更时间"
      ],
      tBody: [
        "spuName",
        "depotName",
        "changeQty",
        "changeType",
        "stockQty",
        "changeOperatorName",
        "changeOperatorTime"
      ],
      skuId: "",
      depotId: "",
      dialogVisible: false,
      importTempVisible: false,
      flowList: [],
      flowListTotal: 0,
      checkedRow: [],
      batchCondition: {
        oldWord: "",
        newWord: "",
        salesState: "open",
        spuPlatFormList: [],
        delFlag: 0,
        spuIdList: []
      },
      searchCondition: {},
      activityChildCategoryList: [],
      currentPage: 1,
      startDate: "",
      endDate: "",
      timeStatus: "",
      pageSize: 10,
      date: [],
      changeTypeList: [],
      promotionCode: "",
      promotionName: "",
      enabledState: "",
      isOutputing: false
    };
  },
  async created() {
    const startTime = moment()
      .subtract(3, "days")
      .format("YYYY-MM-DD HH:mm:ss");
    const endTime = moment().format("YYYY-MM-DD HH:mm:ss");
    this.searchCondition.changeOperatorTime = [startTime, endTime];
    this.getParamsCookie();
    this.depotId = this.$route.query.depotId || "";
    this.skuId = this.$route.query.skuId || "";
    await this.$store.dispatch("querySalesChannels");
    this.$store.dispatch("queryDepotListList", {
      pageNo: 1,
      pageSize: 999999
    });
    await this.queryList();
    this.queryStockChangeType();
  },
  mounted() {},
  computed: mapGetters(["depotList", "mallGoodsList", "salesChannels"]),
  watch: {
    "depotList.records": {
      handler(val) {
        if (val.length && this.depotId) {
          this.searchCondition.depotId = this.depotId;
        }
      },
      deep: true
    },
    activityCategoryList(val) {
      this.activityChildCategoryList = [];
      val.forEach(v => {
        this.activityChildCategoryList = this.activityChildCategoryList.concat(
          v.nodes
        );
      });
    }
  },
  methods: {
    async queryStockChangeType() {
      const { result } = await this.$store.dispatch("queryStockChangeType");
      this.changeTypeList = result;
    },
    submitRuleForm() {
      let batchCondition = JSON.parse(JSON.stringify(this.batchCondition));
      batchCondition.spuIdList = this.checkedRow;
      this.$store.dispatch("batchEdit", batchCondition).then(res => {
        if (res.code === "0") {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.queryList();
          this.dialogVisible = false;
        }
      });
    },
    addGoods() {
      this.$router.push({ name: "AddGoods" });
    },
    edit(row) {
      this.$router.push({
        name: "EditGoods",
        query: {
          spuId: row.spuId
        }
      });
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    remove(row, type) {
      this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let actionName = "deleteGoods";
        let params = {
          spuId: row.spuId
        };
        if (type) {
          actionName = "batchEdit";
          params = {
            spuIdList: row,
            delFlag: 1
          };
        }
        this.$store.dispatch(actionName, params).then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.queryList();
          }
        });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    switchAuditState(id, enabledState) {
      this.$store
        .dispatch("switchAuditState", {
          enabledState,
          id
        })
        .then(() => {
          this.queryList();
        });
    },
    addActivity() {
      this.$router.push({
        name: "SelectActivity"
      });
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    async queryList(queryAll) {
      const params = {
        pageSize: queryAll ? 99999 : this.pageSize,
        pageNo: this.currentPage
      };      
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.changeStartOperatorTime = this.isArray(
        searchCondition.changeOperatorTime
      )
        ? searchCondition.changeOperatorTime[0]
        : "";
      searchCondition.changeEndOperatorTime = this.isArray(
        searchCondition.changeOperatorTime
      )
        ? searchCondition.changeOperatorTime[1]
        : "";
      searchCondition.skuId = this.skuId;
      Object.assign(params, searchCondition);
      this.setParamsCookie();
      const actionName = queryAll ? "queryAllStockFlow" : "queryStockFlow";
      const { result } = await this.$store.dispatch(actionName, params);
      const { records, total } = result;
      records.forEach(v => {
        v.skuName = `${v.spuName}(${v.specIdGroupName})`;
        switch (v.changeType) {
          case "warehouse":
            v.changeTypeFormat = "进货";
            break;
          case "sale":
            v.changeTypeFormat = "销售";
            break;
          case "refund":
            v.changeTypeFormat = "退货";
            break;
          case "allot":
            v.changeTypeFormat = "调拨";
            break;
          default:
            break;
        }
      });
      this.flowList = records;
      this.flowListTotal = total;
    },
    setParamsCookie() {
      setCookie({
        key: "stockFlowParams",
        type: "session",
        data: Object.assign({}, this.searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({ key: "stockFlowParams", type: "session" });
      if (prams) {
        let search = {};
        for (let key in prams) {
          if (key !== "pageSize" && key !== "currentPage") {
            search[key] = prams[key];
          }
        }
        this.searchCondition = search;
        this.skuId = prams.skuId;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    getChecked(selection) {
      this.checkedRow = selection.map(v => v.spuId);
    },
    batchSetting() {
      if (this.checkedRow.length) {
        this.dialogVisible = true;
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    batchDelete() {
      if (this.checkedRow.length) {
        this.remove(this.checkedRow, "batch");
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>

<style scoped lang="scss">
.batch {
  div {
    margin: 20px 0;
    cursor: pointer;
    font-size: 14px;
    color: #222222;
    user-select: none;
    &:first-child {
      margin-right: 20px;
    }
  }
  .hmicon {
    margin-right: 5px;
  }
}

.tabs {
  .title {
    color: #222222;
    padding-left: 10px;
  }
  .tips {
    color: #666;
    font-size: 12px;
    padding-left: 10px;
  }
}
.tips {
  color: #999;
  font-size: 14px;
}
</style>
